import { defineStore } from 'pinia'

import { StorageHelper } from '@/helpers/storage-helper'
import { RepositoryFactory } from '@/repositories/repositoryFactory'

interface AppError {
  message: string
}

interface NavigationStore {
  mappedNavItems: any
  data: any
  dataNavSecond: any
  dataNavThird: any
  dataNavFourth: any
  dataNavQuickLinks: any
  dataNavUpper: any
  dataNavLower: any
  isLoaded: boolean
  isLoadedUpper: boolean
  isLoadedLower: boolean
  loadingTracker: number
  error: AppError | null
}

const navigationMenuRepository: any = RepositoryFactory.get('navigationMenuRepository')

export const useNavItemsStore = defineStore('navigationItems', {
  state: () =>
    <NavigationStore>{
      mappedNavItems: StorageHelper.getItem('mappedNavItems', []),
      data: StorageHelper.getItem('navigationMenu', []),
      dataNavSecond: StorageHelper.getItem('navSecond', []),
      dataNavThird: StorageHelper.getItem('navThird', []),
      dataNavFourth: StorageHelper.getItem('navFourth', []),
      dataNavQuickLinks: StorageHelper.getItem('navQuickLinks', []),
      dataNavUpper: StorageHelper.getItem('navUpper', []),
      dataNavLower: StorageHelper.getItem('navLower', []),
      isLoaded: false,
      isLoadedUpper: false,
      isLoadedLower: false,
      loadingTracker: 0,
      error: null
    },
  getters: {
    getmappedNavItems: (state) => state.mappedNavItems,
    getNavItems: (state) => state.data,
    getNavSecondItems: (state) => state.dataNavSecond,
    getNavThirdItems: (state) => state.dataNavThird,
    getNavFourthItems: (state) => state.dataNavFourth,
    getNavQuickLinks: (state) => state.dataNavQuickLinks,
    getNavUpper: (state) => state.dataNavUpper,
    getNavLower: (state) => state.dataNavLower,
    getIsLoaded: (state) => state.isLoaded,
    getIsLoadedUpper: (state) => state.isLoadedUpper,
    getIsLoadedLower: (state) => state.isLoadedLower
  },
  actions: {
    updateMapNavItems(payload: boolean) {
      this.mappedNavItems = payload
    },
    updateIsLoaded(payload: boolean) {
      this.isLoaded = payload
    },

    updateIsLoadedUpper(payload: boolean) {
      this.isLoadedUpper = payload
    },
    updateIsLoadedLower(payload: boolean) {
      this.isLoadedLower = payload
    },
    async fetchButterUpperNav() {
      try {
        this.dataNavUpper = await navigationMenuRepository.getUpperNavigationMenu()
        this.error = null
        StorageHelper.setItem('navUpper', this.dataNavUpper)
      } catch (error) {
        console.error('Error fetching:', error)
        this.error = {
          message: 'problem with fetching upper menu'
        }
      }
    },
    async fetchButterNav() {
      this.loadingTracker++
      try {
        this.data = await navigationMenuRepository.getNavigationMenu()
        this.error = null
        StorageHelper.setItem('navigationMenu', this.data)
      } catch (error) {
        console.error('Error fetching:', error)
        this.error = {
          message: 'problem with fetching menu'
        }
      } finally {
        this.loadingTracker--
        this.checkIsLoaded()
      }
    },

    async fetchButterSecondNav() {
      this.loadingTracker++
      try {
        this.dataNavSecond = await navigationMenuRepository.getNavigationSecondMenu()
        this.error = null
        StorageHelper.setItem('navSecond', this.dataNavSecond)
      } catch (error) {
        console.error('Error fetching:', error)
        this.error = {
          message: 'problem with fetching second menu'
        }
      } finally {
        this.loadingTracker--
        this.checkIsLoaded()
      }
    },

    async fetchButterThirdNav() {
      this.loadingTracker++
      try {
        this.dataNavThird = await navigationMenuRepository.getNavigationThirdMenu()
        this.error = null
        StorageHelper.setItem('navThird', this.dataNavSecond)
      } catch (error) {
        console.error('Error fetching:', error)
        this.error = {
          message: 'problem with fetching second menu'
        }
      } finally {
        this.loadingTracker--
        this.checkIsLoaded()
      }
    },

    async fetchButterFourthNav() {
      this.loadingTracker++
      try {
        this.dataNavFourth = await navigationMenuRepository.getNavigationFourthMenu()
        this.error = null
        StorageHelper.setItem('dataNavFourth', this.dataNavFourth)
      } catch (error) {
        console.error('Error fetching:', error)
        this.error = {
          message: 'problem with fetching fourth menu'
        }
      } finally {
        this.loadingTracker--
        this.checkIsLoaded()
      }
    },

    async fetchButterSecondQuickLinks() {
      this.loadingTracker++
      try {
        this.dataNavQuickLinks = await navigationMenuRepository.getNavigationQuickLinks()
        this.error = null
        StorageHelper.setItem('navQuickLinks', this.dataNavQuickLinks)
      } catch (error) {
        console.error('Error fetching:', error)
        this.error = {
          message: 'problem with fetching quick links'
        }
      } finally {
        this.loadingTracker--
        this.checkIsLoaded()
      }
    },

    async fetchButterLowerNavData() {
      this.loadingTracker++
      try {
        this.dataNavLower = await navigationMenuRepository.getLowerNavData()
        this.error = null
        StorageHelper.setItem('navLower', this.dataNavLower)
      } catch (error) {
        console.error('Error fetching:', error)
        this.error = {
          message: 'problem with fetching lower menu'
        }
      } finally {
        this.loadingTracker--
        this.checkIsLoaded()
      }
    },

    checkIsLoaded() {
      if (this.loadingTracker === 0) {
        this.isLoaded = false
      }
    }
  }
})
